import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";

import { useLocation, Navigate } from "react-router-dom";
import { Spinner, Container, Row, Col } from "react-bootstrap";
import { TUTOR_ONBOARDING_API } from "../../api/api";

const TutorRouteGuard = ({ children }) => {
  const [status, setStatus] = useState(null); // null | pending | published | rejected
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const fetchStatus = useCallback(async () => {
    const userId = localStorage.getItem("user_id");

    if (!userId) {
      setStatus(null);
      setLoading(false);
      return;
    }

    try {
      const res = await axios.post(
        TUTOR_ONBOARDING_API.TUTOR_USER_ROUTES_GET_USER,
        { user_id: userId },
      );
      
      const tutorStatus = res.data?.user?.status ?? null;
      setStatus(tutorStatus ? tutorStatus.toLowerCase() : null);
    } catch (err) {
      console.error(err);
      setStatus(null);
    } finally {
      setLoading(false);
    }
  }, []);

  // refetch when route changes
  useEffect(() => {
    fetchStatus();
  }, [fetchStatus, location.pathname]);

  if (loading) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ height: "80vh" }}
      >
        <Row>
          <Col className="text-center">
            <Spinner animation="border" variant="primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Col>
        </Row>
      </Container>
    );
  }

  // Current path
  const path = location.pathname;

  // If tutor is not onboarded
  if (!status || status === "null") {
    if (!path.startsWith("/tutor-onboarding")) {
      return <Navigate to="/tutor-onboarding" replace />;
    }
  }

  // Pending tutors → can only see under-review page
  if (status === "pending") {
    if (!path.startsWith("/tutor-dashboard-under-review")) {
      return <Navigate to="/tutor-dashboard-under-review" replace />;
    }
  }

  // Rejected tutors → can see under-review or onboarding (to edit)
  if (status === "rejected") {
    if (
      !path.startsWith("/tutor-dashboard-under-review") &&
      !path.startsWith("/tutor-onboarding")
    ) {
      return <Navigate to="/tutor-dashboard-under-review" replace />;
    }
  }

  // Published tutors → cannot access onboarding or under-review pages
  if (status === "published") {
    if (
      path.startsWith("/tutor-onboarding") ||
      path.startsWith("/tutor-dashboard-under-review")
    ) {
      return <Navigate to="/header/tutor/dashboard" replace />;
    }
  }

  return children;
};

export default TutorRouteGuard;
